import { apiReducer } from 'utils/API'
import {
  BILLET_FILTERS
} from '../constants'

export default apiReducer({
  entity: BILLET_FILTERS,
})